"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Contentvideo = function Contentvideo(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ContentvideoTitle ContentvideoDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ContentvideoTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ContentvideoDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M14.05 17.931H2.057A1.428 1.428 0 0 1 .63 16.517V7.194a1.43 1.43 0 0 1 1.426-1.426H14.05c.789 0 1.427.638 1.429 1.426v9.322a1.428 1.428 0 0 1-1.429 1.415zM2.057 6.876a.33.33 0 0 0-.33.329v9.311a.33.33 0 0 0 .33.33H14.05c.183 0 .33-.148.332-.33V7.194a.332.332 0 0 0-.33-.33H2.058v.012zM22.64 17.849h-.005a.714.714 0 0 1-.274-.054l-.06-.028-5.22-2.926a.72.72 0 0 1-.41-.65V9.489c0-.286.167-.532.41-.647l5.295-2.93a.722.722 0 0 1 .985.672V17.13a.722.722 0 0 1-.722.722l.001-.002zm-4.87-3.883l4.495 2.518V7.22l-4.494 2.504v4.241z"
  }));
};

Contentvideo.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Contentvideo.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Contentvideo;
exports["default"] = _default;